import React, {useState, useEffect} from 'react';
import cx from 'classnames';
import _ from 'lodash';
import Avatar from 'react-avatar';

import Button from './ButtonNew';
import {CommentMarkdown} from './Markdown';
import {SimpleLockIcon} from './svg';
import {useAppContext} from '../hooks';

const minLength = 250;

const CommentPaywall = ({isPaywalled, onClickUpgrade, children}) => (isPaywalled ? (
  <div>
    <div className="relative">
      <div className="absolute bottom-0 top-0 left-0 right-0 bg-gradient-to-t from-white z-10" />
      {children}
    </div>
    <div className="flex flex-col items-center">
      <span className="mt-2 text-center text-base font-medium text-black">
        <SimpleLockIcon className="w-4 h-4 mb-1 mr-1 text-black" />
        Access expert answers by becoming a member
      </span>
      <Button
        href="/upgrade?src=expert-answer"
        onClick={onClickUpgrade}
        className="my-2"
      >
        Upgrade
      </Button>
    </div>
  </div>
) : children);

const ExpertAnswer = ({
  comment, className, onView = _.noop, onClickUpgrade = _.noop,
}) => {
  const [readMore, setReadMore] = useState(comment.data.text.length < minLength);
  const {hasSubscription} = useAppContext();

  useEffect(() => {
    onView();
  }, []);

  const answerText = hasSubscription
    ? comment.data.text
    : _.truncate(comment.data.text, {length: 200, separator: ' '});

  return (
    <div className={cx('flex flex-col border border-gray-200 rounded-lg p-5', className)}>
      <p className="mb-2 text-xs font-semibold text-indigo uppercase tracking-wide">expert answer</p>
      <CommentPaywall isPaywalled={!hasSubscription} onClickUpgrade={onClickUpgrade}>
        <div className="flex flex-row mb-4 items-center">
          <Avatar
            className="comment-profile-img"
            name={comment.displayName}
            src={comment.profile_img || null}
            color="#f0f0f0"
            fgColor="#000000"
            size={40}
          />
          <div className="flex flex-col">
            <p className="font-semibold">{comment.displayName}</p>
          </div>
        </div>
        <div className={cx('prose relative pl-1 pt-2', {'comment-message-chop': !readMore})}>
          <CommentMarkdown>{answerText}</CommentMarkdown>
        </div>
        {hasSubscription && !readMore && (
          <div>
            <button
              type="button"
              className="CommentButton CommentButton--outline"
              onClick={() => setReadMore(true)}
            >
              Read More
            </button>
          </div>
        )}
      </CommentPaywall>
    </div>
  );
};

export default ExpertAnswer;
